import { Box } from "@mui/material";
import { Dispatch, SetStateAction, useContext, useState } from "react";
import { ToggleNeurofeedbackItems } from "./ToggleNeurofeedbackItems";
import { RecordsRelated } from "../../../../components/recordsRelated/RecordsRelated";
import { fieldsQueryArray } from "../../utils";
import { neuroFeebackDataFilter } from "./utils";
import { RecordContext } from "../../../../components/record/Record";
import { neurofeedbackSessionsOptions } from "../../neurofeedbackSessionsOptions";
import { UseRecordsOptions } from "../../../../api/useRecords";
import { NeurofeedbackScoresPresentation } from "./NeurofeedbackScoresPresentation";

type NeurofeedbackRelatedProps = {
    heightOfHeaders: number;
};

export type NeurofeedbackView = {
    entity: string;
    fieldsQuery: string;
    filter: any;
    relatedParams?: string;
    recordsOptions?: UseRecordsOptions; 
};

export const nfbDataFieldsQuery = fieldsQueryArray.join(",");

export const NeurofeedbackRelated = ({ heightOfHeaders }: NeurofeedbackRelatedProps) => {
    const parentRecordContext = useContext(RecordContext);
    const treatmentId = parentRecordContext?.item?.id;

    const [neurofeedbackView, setNeurofeedbackView] = useState<NeurofeedbackView>({
        entity: "neurofeedback_data",
        fieldsQuery: nfbDataFieldsQuery,
        filter: neuroFeebackDataFilter,
        recordsOptions: neurofeedbackSessionsOptions,
    });

    return (
        <Box> 
            {neurofeedbackView.filter && (
                <RecordsRelated
                    entity={neurofeedbackView.entity}
                    fieldsToQuery={neurofeedbackView.fieldsQuery}
                    customFilter={(params) => neurofeedbackView.filter(params.parentId)}
                    heightOfHeaders={heightOfHeaders}
                    recordsOptions={{ relatedRecords: { hideCreationButton: true }, extraOptions: { sort: "-date_created" }, ...neurofeedbackView.recordsOptions }}
                    customComponentHeaderStyles={{ justifyContent: "flex-start" }}
                    customComponentHeader={
                       <NFBInformation
                            treatmentId={treatmentId}
                            neurofeedbackView={neurofeedbackView}
                            setNeurofeedbackView={setNeurofeedbackView}
                        />
                    }
                />
            )}
        </Box>
    );
};


type NFBInformationProps = {
    treatmentId: string;
    neurofeedbackView: NeurofeedbackView;
    setNeurofeedbackView: Dispatch<SetStateAction<NeurofeedbackView>>;
};
const NFBInformation = ({ treatmentId, neurofeedbackView, setNeurofeedbackView }: NFBInformationProps) => {
    const itemsWidth = "230px";
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                flex: 1,
                gap: 4,
                p:4,
            }}
        >
            <ToggleNeurofeedbackItems
                setNeurofeedbackView={setNeurofeedbackView}
                neurofeedbackView={neurofeedbackView}
                treatmentId={treatmentId}
                buttonWidth={itemsWidth}
            />
            {neurofeedbackView.entity === "neurofeedback_data" && (
                <NeurofeedbackScoresPresentation treatmentId={treatmentId} cardWidth={itemsWidth} />
            )}
        </Box>
    );
};